function focusOnDirective() {
    'ngInject';

    return {
        restrict: 'A',
        controller: function focusOnController($scope, $element, $attrs, $timeout) {

            function focus() {
                $timeout(() => $element.focus());
            }

            const events = $attrs.bbFocusOn.split(',');

            if (Array.isArray(events)) {
                events.forEach((event) => {
                    $scope.$on(event, focus);
                });
            } else {
                $scope.$on(events, focus);
            }
        }
    };
}

// Allows you to focus on a specific element when an event is raised
angular
    .module('BB')
    .directive('bbFocusOn', focusOnDirective);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/focus-on/focus_on.directive.js